import { toast } from "react-toastify";
function ToastMessages(msg){
toast.error(msg,{ position: toast.POSITION.TOP_CENTER, autoClose: true })
}
export default ToastMessages;